/**
 * Error boundary for lazy-loaded route chunks.
 * Catches chunk load errors and shows a retry button.
 */

import { Component, type ReactNode } from 'react';

interface Props {
  readonly children: ReactNode;
}

interface State {
  readonly hasError: boolean;
}

export class RouteErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  private handleRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex h-full flex-col items-center justify-center gap-4 p-8">
          <p className="text-lg text-gray-600">Failed to load page. Please try again.</p>
          <button
            onClick={this.handleRetry}
            className="rounded-md bg-brand-teal px-4 py-2 text-white hover:bg-brand-teal/90"
          >
            Retry
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
